<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "DefaultLayout"
}
</script>

<style >
html, body, #app{
  background-color: gray;
  min-width: 1400px;
  margin: 0;
  padding: 0;
  /*height: 100vh;*/
  width: 100%;
  border: 0;
  font-size: 100%;
  line-height: 1.2;
  font: inherit;      /* 所有元素字体一致 */
  vertical-align: baseline;      /* 行内元素垂直对齐：父级元素基线 */
  text-align: center;            /* 水平居中 */

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

  color: #000000;
}

/* 移动端适配 */
@media screen and (max-width: 425px) {


  html, body, #app{
    background-color: gray;
    min-width: 400px;
    max-width: 1024px;
    margin: 0;
    padding: 0;
    /*height: 100vh;*/
    width: 100%;
    border: 0;
    font-size: 100%;
    line-height: 1.2;
    font: inherit;      /* 所有元素字体一致 */
    vertical-align: baseline;      /* 行内元素垂直对齐：父级元素基线 */
    text-align: center;            /* 水平居中 */

    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

    color: #000000;
  }
}


@media screen and (max-width: 768px) {


  html, body, #app{
    background-color: gray;
    min-width: 400px;
    max-width: 1024px;
    margin: 0;
    padding: 0;
    /*height: 100vh;*/
    width: 100%;
    border: 0;
    font-size: 100%;
    line-height: 1.2;
    font: inherit;      /* 所有元素字体一致 */
    vertical-align: baseline;      /* 行内元素垂直对齐：父级元素基线 */
    text-align: center;            /* 水平居中 */

    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

    color: #000000;
  }
}
</style>
